import { client, validateClientProperty } from "@/lib/ts-rest"
import { useEffect } from "react"
import { trackEvent } from "@/lib/log"

export function Billing() {
  const { data } = client.getStripePortalLink.useQuery({
    queryKey: [validateClientProperty("getStripePortalLink")],
  })

  useEffect(() => {
    if (data?.body.url) {
      trackEvent("redirected to billing portal")
      window.open(data.body.url, "_self")
    }
  }, [data])

  if (!data) return <div className="text-sm text-gray-500">Redirecting to Stripe...</div>

  return (
    <a href={data.body.url} className="text-sky-600 text-sm">
      Please click here if you are not redirected.
    </a>
  )
}
